import { removeAccount } from './remove-account';
import { apiKeys } from './api-keys';
import { presets } from './presets';

export const settingsArticles = [
  removeAccount,
  apiKeys,
  presets
]; 